









































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Surface, Typography, Picture } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';

import eventBus from '@/utils/eventBus';

@Component({ components: { Surface, Typography, Picture, FilledButton } })
export default class CampaignActivationModal extends Vue {
  @Prop() readonly status?: boolean;
  @Prop() readonly campaignId?: string;
  @Prop() readonly hasActiveCampaign?: boolean;

  onClose() {
    eventBus.$emit('closeModal');
  }

  async onConfirm() {
    this.onClose();
    eventBus.$emit('changeFreeCoinCampaignStatus', {
      status: this.status,
      id: this.campaignId
    });
  }
}
